export class CreateServiceMessage {
  allowDiscounts: boolean
  buildStepId: number
  description: string
  name: string
  price: number
  sku: string

  constructor(allowDiscounts: boolean, buildStepId: number, description: string, name: string, price: number, sku: string) {
    this.allowDiscounts = allowDiscounts
    this.buildStepId = buildStepId
    this.description = description
    this.name = name
    this.price = price
    this.sku = sku
  }
}